import { useEffect } from 'react'
import { useEditor } from 'tldraw'

export function LoadImageFromUrl() {
    const editor = useEditor();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let imgUrl = params.get('img')

        console.log('imgUrl', imgUrl);

        if(imgUrl == "Sedan"){
          imgUrl = `/Sedan_43d858a6df.png`;
        }
        if(imgUrl == "Hatchback"){
          imgUrl = `/Hatchback_f14d059dff.png`;
        }
        if(imgUrl == "Pick-up"){
          imgUrl = `/Pickup_5628c7a141.png`;
        }
        if(imgUrl == "SUV"){
          imgUrl = `/SUV_89316d4d21.png`;
        }
        if(imgUrl == "Coupe"){
          imgUrl = `/Coupe_5f5915952d.png`;
        }
        if(imgUrl == "Roadster"){
          imgUrl = `/Roadster_2edb74d0f6.png`;
        }
        if(imgUrl == "Minivan"){
          imgUrl = `/Minivan_db82b9b345.png`;
        }
        if(imgUrl == "Camión"){
          imgUrl = `/Camion_7f7216d358.png`;
        }
        if(imgUrl == "Microbus"){
          imgUrl = `/Microbus_f2492b7ed0.png`;
        }
        if(imgUrl == "Motocicleta"){
          imgUrl = `/Motocicleta_1f1e2e7d7d.png`;
        }

        if (!imgUrl || !editor) return

        const assetId = 'asset:' + Date.now();

        // Tamaño deseado de la imagen
        const width = 1280
        const height = 900

        // 1. Crear el asset
        editor.createAssets([
        {
            id: assetId,
            typeName: 'asset',
            type: 'image',
            meta: {}, 
            props: {
                name: 'image',
                isAnimated: false,
                mimeType: 'image/png',
                src: imgUrl,
                w: width,
                h: height,
            },
        },
        ])


        // 2. Crear la shape de imagen
        editor.createShape({

            type: 'image',
            x: 50,
            y: 50,
            props: {
                assetId,
                w: width,
                h: height,
            },
        })
    }, [editor])

    return null
}
